import { Injectable } from '@angular/core';
import { AngularFireStorage } from 'angularfire2/storage';
import { finalize } from 'rxjs/operators';
import { environment as env } from './../../environments/environment';
import { MainService } from './api/main.service';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

	path: any = null;
	file: any = null;
	filename: any = null;
	newFilename: any = null;

	/* upload vars */
	ref: any = null;
	task: any = null;
	uploadProgress: any = null;
	url: any = null;

	uploaderUrl = 'https://firebase.entrelabel.com/uploader.php';

	constructor(
		public afStorage: AngularFireStorage,
		public mainService: MainService
	) {

	}

	/**
	 * set the file to be uploaded
	 */
	setFile(file){
		let d = new Date();
		let n = d.getTime();
		this.file = file;
		this.filename = n + '-' + file.target.files[0].name;
		return this;
	}

	/**
	 * set the path where to upload the file
	 */
	setPath(path: any = null){
		this.path = env.firebase_path_prefix + path;
		return this;
	}

	/**
	 * generate file name recursively,
	 * this also check if it is exist on the firebase storage or not
	 * on error mean the name is not exist and ready to be used 
	 * as filename to upload
	 */
	getGenerateName(prefix: any = 0) {
		return new Promise(resolve => {
			let path = this.path + prefix + '_' + this.filename;
			if(prefix == 0){
				path = this.path + this.filename;
			}
			
			let file = this.afStorage.ref(path);
			const test = file.getDownloadURL().subscribe(url => {
				prefix++;
				resolve(this.getGenerateName(prefix));
			}, error => {
				this.newFilename = prefix + '_' + this.filename;
				if(prefix == 0){
					this.newFilename = this.filename;
				}
				resolve(this.newFilename);
			});
		});
	}

	/**
	 * start the upload to firebase storage
	 * return the download url
	 */
	upload(i = 0){
		return new Promise(resolve => {
			let event = this.file;
			let path = this.path + this.newFilename;
			this.ref = this.afStorage.ref(path);
			this.task = this.ref.put(event.target.files[i]);
			this.uploadProgress = this.task.percentageChanges();
			this.task.snapshotChanges().pipe(
			    finalize(() => {
			    	this.ref.getDownloadURL().subscribe(url=>{
						if(url){
							this.url = url;
							resolve(url);
						} else {
							resolve(null);
						}
					})
			    })
			 )
			.subscribe();
		});
	}

	/**
	 * this will upload the file on the server first 
	 * then let the server upload it on firebase
	 * the reason for this is because of some user get stock on uploading
	 * if the upload() method is used.
	 * this is created at June 3, 2021
	 * @returns 
	 */
	_uploadProgress:any = {};
	uploadToServer(progressKey:any = null){
		return new Promise(resolve => {
			let path = this.path;
			let file = this.file.target.files[0];

			let formData = new FormData();
			formData.append('attachment', file);
			formData.append('path', path);

			let request = new XMLHttpRequest();
			request.open('POST', this.uploaderUrl); 

			request.upload.addEventListener('progress', (e) => {
				this.uploadProgress = (e.loaded / e.total)*100;

				if(progressKey){ /** this is for quick order page */
					/** 
					 * start:  quick order page for add multiple items to cart
					 */
					this.mainService.toastService.addingTocart.currentUploadingFileKey = progressKey;
					this.mainService.toastService.addingTocart.uploadProgress = this.uploadProgress;
					this.mainService.toastService.addingTocart.uploadingFileName = file.name;
					/** 
					 * end: quick order page for add multiple items to cart
					 */

					this._uploadProgress[progressKey] = this.uploadProgress;
				}
			});

			// AJAX request finished event
			request.addEventListener('load', (e) => {
				if(request.status == 200){
					let response = JSON.parse(request.response);

					this.task = {
						task: response[0]['firestore_task']
					}
					this.newFilename = response[0]['firestore_task']['newFilename'];

					resolve(response[0]['firestore_task']['downloadUrl']);
				} else {
					resolve(null);
					this.mainService.toastService.add(request.response, 'danger')
				}
			});

			// send POST request to server side script
			request.send(formData);



			// {
			// 	"Content-Type": 'multipart/form-data',
			// }
			// this.mainService.post(url, formData, null, true).subscribe(result => {
			// }, error => {
				
			// });
		});
	}
}
